import React from 'react';

interface PutterFieldsProps {
  clubName: string;
  club: any;
  handleProfileChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const PutterFields: React.FC<PutterFieldsProps> = ({ clubName, club, handleProfileChange }) => {
  return (
    <>
      <div className="form-field">
        <label htmlFor={`${clubName}.head_style`}>Head Style</label>
        <select
          id={`${clubName}.head_style`}
          name={`${clubName}.head_style`}
          value={club?.head_style || ''}
          onChange={handleProfileChange}
        >
          <option value="" disabled>Select...</option>
          <option value="blade">Blade</option>
          <option value="mallet">Mallet</option>
          <option value="semi_mallet">Semi-Mallet</option>
        </select>
      </div>
      <div className="form-field">
        <label htmlFor={`${clubName}.toe_hang`}>Toe Hang</label>
        <select
          id={`${clubName}.toe_hang`}
          name={`${clubName}.toe_hang`}
          value={club?.toe_hang || ''}
          onChange={handleProfileChange}
        >
          <option value="" disabled>Select...</option>
          <option value="face_balanced">Face Balanced</option>
          <option value="slight">Slight Toe Hang</option>
          <option value="strong">Strong Toe Hang</option>
        </select>
      </div>
      <div className="form-field">
        <label htmlFor={`${clubName}.length`}>Length <br />(inches)</label>
        <input
          type="number"
          id={`${clubName}.length`}
          name={`${clubName}.length`}
          value={club?.length || ''}
          onChange={handleProfileChange}
          placeholder="e.g., 34"
        />
      </div>
      <div className="form-field">
        <label htmlFor={`${clubName}.stroke_type`}>Stroke Type</label>
        <select
          id={`${clubName}.stroke_type`}
          name={`${clubName}.stroke_type`}
          value={club?.stroke_type || ''}
          onChange={handleProfileChange}
        >
          <option value="" disabled>Select...</option>
          <option value="slight_arc">Slight Arc</option>
          <option value="strong_arc">Strong Arc</option>
          <option value="straight_back_straight_through">Straight Back Straight Through</option>
        </select>
      </div>
      <div className="form-field">
        <label htmlFor={`${clubName}.alignment_preference`}>Alignment <br />Preference</label>
        <select
          id={`${clubName}.alignment_preference`}
          name={`${clubName}.alignment_preference`}
          value={club?.alignment_preference || ''}
          onChange={handleProfileChange}
        >
          <option value="" disabled>Select...</option>
          <option value="lines">Lines</option>
          <option value="dots">Dots</option>
          <option value="none">None</option>
          <option value="other">Other</option>
        </select>
      </div>
    </>
  );
};

export default PutterFields;
